import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { Product } from '@shared/models/product.model';
import { EasyPricingUpdate, ManualUpdateReason } from '@usf/ngrx-pricing';

@Component({
  selector: 'app-pme-right-rail',
  templateUrl: './pme-right-rail.component.html',
  styleUrls: ['./pme-right-rail.component.scss'],
})
export class PMERightRailComponent {
  @Input() product: Product;
  @Input() isMobile = false;
  @Output() productDetailsClick = new EventEmitter<void>();
  @Output() closeSidebar = new EventEmitter<void>();
  @Output() priceChanged = new EventEmitter<EasyPricingUpdate>();
  @Output() closeManualApproval = new EventEmitter<number>();

  @ViewChild('popover') popover!: HTMLIonPopoverElement;

  customPrice = '0.00';
  isPopoverOpen = false;
  targetCasePriceSet = true;
  manualApprovalReason: ManualUpdateReason;
  isManualApprovalOpen = false;

  // Below relies on tandem working
  isTandemWorking = false;

  // REMOVE ME - IM JUST MOCK DATA
  targetPercents = ['1', '2', '3', '4'];

  // REMOVE ME - IM JUST MOCK DATA
  quantities = ['1', '1', '1', '1'];

  // REMOVE ME - IM JUST MOCK DATA
  MTD = ['cpr', 'cpr', 'cpr', 'cpr'];

  constructor() {}

  onCloseSidebar() {
    this.closeSidebar.emit();
  }

  onCloseManualApproval() {
    this.closeManualApproval.emit(this.product.productNumber);
  }

  productDetailsButtonClick() {
    this.productDetailsClick.emit();
  }

  onCustomPriceChange(event: Event) {
    event.stopPropagation();
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const customPrice = parseFloat(value?.replace(/[^0-9.]/g, ''));

    if (
      customPrice &&
      customPrice !== this.product?.easyPricingViewModel?.currentUnitPrice
    ) {
      this.priceChanged.emit({
        productNumber: this.product.productNumber,
        price: customPrice,
        isCustomUpdate: true,
        isManualUpdate: false,
        productUOM: this.product.summary.priceUom,
        trackingAttributes: this.product.trackingAttributes,
      });
    }
  }

  selectTargetPrice(): void {
    this.priceChanged.emit({
      productNumber: this.product.productNumber,
      price: this.product.easyPricingViewModel.targetCasePrice,
      isCustomUpdate: false,
      isManualUpdate: false,
      productUOM: this.product.summary.priceUom,
      trackingAttributes: this.product.trackingAttributes,
    });
  }

  openPopover(event: Event) {
    this.popover.event = event;
    this.isPopoverOpen = true;
  }

  onManualApprovalSubmit(event: Event) {
    event.stopPropagation();
    this.priceChanged.emit({
      isManualUpdate: true,
      productNumber: this.product.productNumber,
      price: this.product.easyPricingViewModel.customPrice,
      isCustomUpdate: true,
      productUOM: this.product.summary.priceUom,
      manualUpdateReason: this.manualApprovalReason,
      trackingAttributes: this.product.trackingAttributes,
    });
  }
}
